import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full mx-auto pb-12 font-light"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "px-4 sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "lg:flex gap-12 items-start" }
const _hoisted_5 = { class: "lg:w-2/3 sticky z-30 top-0" }
const _hoisted_6 = { class: "bg-white md:hidden border-b border-t border-gray-200 py-2 px-4 flex justify-center" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "mt-20 bg-brand-gray w-full" }
const _hoisted_9 = { class: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-10" }
const _hoisted_10 = { class: "text-4xl font-ivymode font-minerva" }

import {computed, onMounted, ref} from 'vue'
import {useStore} from 'vuex'
import {Diamond} from '@/store/modules/diamonds'
import DiamondNav from '@/components/diamonds/DiamondNav.vue'
import DiamondImages from '@/components/diamonds/details/DiamondImages.vue'
import DiamondInfo from '@/components/diamonds/details/DiamondInfo.vue'
import DiamondDetailCarat from '@/components/diamonds/details/DiamondDetailCarat.vue'
import DiamondDetailColor from '@/components/diamonds/details/DiamondDetailColor.vue'
import DiamondDetailClarity from '@/components/diamonds/details/DiamondDetailClarity.vue'
import DiamondDetailCut from '@/components/diamonds/details/DiamondDetailCut.vue'
import DiamondDetailFluorescence from '@/components/diamonds/details/DiamondDetailFluorescence.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsDiamondDetails',
  props: {
    diamondId: {}
  },
  setup(__props: any) {

const props = __props

const store = useStore()

const diamond = computed<Diamond | null>(() => store.getters['diamonds/getDiamondById'](props.diamondId))
const imageIdx = ref<string>("-1")
const host = process.env.VUE_APP_HOST || "";

const getFormName = (form: string) => {
  const forms: Record<string, string> = {
    BR: 'Brilliant',
    PR: 'Princess',
    CU: 'Cushion',
    OV: 'Oval',
    PS: 'Pear',
    EM: 'Emerald',
    MQ: 'Marquise',
    RA: 'Radiant',
    HS: 'Heart',
    TR: 'Trillion',
  }
  return forms[form] || form
}

const diamondTitle = computed(() => {
  if (!diamond.value) return ''
  return `${getFormName(diamond.value.form)} ${diamond.value.size.toLocaleString('de-DE')} ct.`
})

const fetchDiamond = async () => {
  await store.dispatch('diamonds/fetchDiamond', props.diamondId)
}

onMounted(() => {
  fetchDiamond()
})

return (_ctx: any,_cache: any) => {
  return (diamond.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(DiamondNav, { title: diamondTitle.value }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(DiamondImages, {
                  class: "sticky z-40 top-0 bg-white aspect-square md:aspect-auto md:h-auto",
                  certificate: diamond.value.certificate,
                  diamond: diamond.value,
                  "image-idx": imageIdx.value,
                  onSwitchImage: _cache[0] || (_cache[0] = (event) => imageIdx.value = event)
                }, null, 8, ["certificate", "diamond", "image-idx"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("ul", _hoisted_7, [
                      _createElementVNode("li", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (imageIdx.value = '-1')),
                        class: "py-2 px-1"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["border-gray-900 rounded-full w-3 h-3 border", {
                'bg-gray-900': imageIdx.value == '-1',
                  }])
                        }, null, 2)
                      ]),
                      (diamond.value.image_url)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (imageIdx.value = '0')),
                            class: "py-2 px-1"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["border-gray-900 rounded-full w-3 h-3 border", {
                'bg-gray-900': imageIdx.value == '0',
                  }])
                            }, null, 2)
                          ]))
                        : _createCommentVNode("", true),
                      false
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 1,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (imageIdx.value = '1')),
                            class: "py-2 px-1"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["border-gray-900 rounded-full w-3 h-3 border", {
                'bg-gray-900': imageIdx.value == '1',
                  }])
                            }, null, 2)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (imageIdx.value = '2')),
                        class: "py-2 px-1"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["border-gray-900 rounded-full w-3 h-3 border", {
                'bg-gray-900': imageIdx.value == '2',
                  }])
                        }, null, 2)
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode(DiamondInfo, {
                class: "lg:w-1/3",
                diamond: diamond.value
              }, null, 8, ["diamond"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("components.diamonds.details.fourCs.title")), 1)
            ]),
            _createVNode(DiamondDetailCarat, {
              class: "py-8",
              carat: diamond.value.size,
              form: diamond.value.form,
              width: diamond.value.width,
              length: diamond.value.length
            }, null, 8, ["carat", "form", "width", "length"]),
            _createVNode(DiamondDetailColor, {
              class: "py-8",
              color: diamond.value.color,
              colored: diamond.value.colored
            }, null, 8, ["color", "colored"]),
            _createVNode(DiamondDetailClarity, {
              class: "py-8",
              clarity: diamond.value.clarity
            }, null, 8, ["clarity"]),
            (diamond.value.form == 'BR')
              ? (_openBlock(), _createBlock(DiamondDetailCut, {
                  key: 0,
                  class: "py-8",
                  cut: diamond.value.cut,
                  "stone-type": diamond.value.type
                }, null, 8, ["cut", "stone-type"]))
              : _createCommentVNode("", true),
            _createVNode(DiamondDetailFluorescence, {
              class: "py-8",
              fluorescence: diamond.value.fluorescence
            }, null, 8, ["fluorescence"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})